<script setup>
  import { ref, defineProps, defineEmits } from 'vue'
  import { ElMessage, ElMessageBox } from 'element-plus'
  import { pushSubscriptionHistory } from '@/api/registrationSubscription'

  const props = defineProps({
    meetingCode: { type: String, required: true },
    subscription: { type: Object, required: true },
  })
  const emit = defineEmits(['close'])
  const busy = ref(false)
  const enrich = ref(false)
  const started = ref(false)
  const done = ref(false)
  const failed = ref(false)
  const scanned = ref(0)
  const queued = ref(0)
  const cursor = ref({ afterId: '0' })
  async function start() {
    if (busy.value || done.value) return
    if (!started.value && enrich.value) {
      try {
        await ElMessageBox.confirm(
          '将为缺少新版内容的报名结果生成新事件，补齐表单标题及实名资料，接收方将再次收到这些结果。确认补推？',
          '完善数据补推',
          { type: 'warning', confirmButtonText: '确认补推', cancelButtonText: '取消' }
        )
      } catch (error) {
        return
      }
    }
    started.value = true
    busy.value = true
    failed.value = false
    try {
      let hasMore = true
      while (hasMore) {
        const { data } = await pushSubscriptionHistory(props.meetingCode, props.subscription.id, {
          ...cursor.value,
          enrich: enrich.value,
        })
        cursor.value = { afterId: data.afterId, upperId: data.upperId, generation: data.generation }
        scanned.value += data.scanned
        queued.value += data.queued
        hasMore = data.hasMore
      }
      done.value = true
      ElMessage.success('历史补推已入队')
    } catch (error) {
      failed.value = true
    } finally {
      busy.value = false
    }
  }
</script>

<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="!busy"
    :model-value="true"
    :show-close="!busy"
    title="历史补推"
    width="520px"
    @close="emit('close')"
  >
    <p>接收方：{{ subscription.receiverName }}</p>
    <p>按当前订阅范围补推历史报名的最新结果，已生成推送记录的结果会跳过。失败记录请在推送记录中重试。</p>
    <el-checkbox v-model="enrich" :disabled="started">完善数据补推（补齐标题及实名资料）</el-checkbox>
    <p>旧任务重试仍发送原报文。勾选后仅对尚无新版内容的报名结果生成新事件，不重复入队已有新版结果。</p>
    <p>已扫描 {{ scanned }} 条，新增入队 {{ queued }} 条。</p>
    <el-alert v-if="busy" :closable="false" title="正在分批入队，请保持页面打开" type="info" />
    <el-alert
      v-if="failed"
      :closable="false"
      title="补推中断，可继续；已完成的批次不会重复入队。订阅变更后请关闭并重新开始。"
      type="error"
    />
    <el-alert v-if="done" :closable="false" title="入队完成，实际投递结果请查看推送记录" type="success" />
    <template #footer>
      <el-button :disabled="busy" @click="emit('close')">关闭</el-button>
      <el-button v-if="!done" :loading="busy" type="primary" @click="start">
        {{ failed ? '继续补推' : '开始补推' }}
      </el-button>
    </template>
  </el-dialog>
</template>
